import React from 'react'
import Button from "../Button";
import Card from "../Card";

// Types ----

type SupportCardProps = {
  imageSrc?: string
  heading: string
  description: string
  buttonText?: string
  onClick: () => void
}

// Component ----

function ActionCard({ imageSrc, heading, description, buttonText, onClick }: SupportCardProps) {
  return (
    <Card>
      <div className='flex flex-col gap-7 flex-grow'>
        <div className='w-28 h-28 bg-gray-200 rounded-full self-center p-5'>
          <img src={imageSrc} className='w-full h-full' alt=''/>
        </div>

        <div className='flex flex-col gap-2'>
          <h2 className="text-lg font-medium leading-6 text-gray-900">{heading}</h2>
          <p className="mt-1 text-sm text-gray-500">{description}</p>
        </div>

        <div className='mt-auto'>
          <Button
            color={Button.colors.PRIMARY}
            onClick={onClick}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Card>
  );
}

export {ActionCard};